import SetupStep from './SetupStep';

function StepRun() {
  return (
    <SetupStep
      id="step-run"
      index="03"
      kicker="RUN"
      title="Enable Automated Trading & Monitor."
      intro="With the EA attached and configured, turn on automated trading and let the system operate. From here it watches the market and manages its own positions."
      panelLabel="RUN CHECKLIST"
      note="The system acts on its defined conditions — it will not trade every price move. Keep the terminal running so the EA can operate continuously."
      points={[
        {
          title: 'Enable AutoTrading',
          detail:
            'Switch on the AutoTrading button in the MT5 toolbar so the platform is allowed to place automated trades.',
        },
        {
          title: 'Verify the EA state',
          detail:
            'Confirm the EA shows an active, allowed state on the chart — a small status marker appears in the chart corner when it is running.',
        },
        {
          title: 'Monitor the terminal',
          detail:
            'Watch the chart, Market Watch and the Experts and Trade tabs to follow activity and any messages from the EA.',
        },
        {
          title: 'Review the record',
          detail:
            'Every closed position becomes part of your trading record — the same history shown in the Trade Journal.',
        },
      ]}
    />
  );
}

export default StepRun;